import {
  SketchEntitiesTransformCommand,
  canShowSketchPropertySection,
  registerPropertyManagerSection,
} from '@/core';
import SketchRotateEntitiesPropertySection from '@/components/editor/property-manager/entities-transform/SketchRotateEntitiesPropertySection.vue';

registerPropertyManagerSection({
  id: 'sketch-rotate-entities',
  title: '旋转实体',
  order: 20,
  component: SketchRotateEntitiesPropertySection,
  exclusive: true,
  actions: {
    confirm: true,
    cancel: true,
  },
  resolveConfirmDisabled: (context) => context.sketchEntitiesTransformState?.canConfirm === false,
  isApplicable: (context) => {
    return canShowSketchPropertySection(
      context,
      context.isSketchActive
        && context.activeCommand === SketchEntitiesTransformCommand.Rotate
        && context.sketchEntitiesTransformState?.active === true,
    );
  },
  onConfirm: (context) => {
    void context.confirmSketchEntitiesTransform?.();
  },
  onCancel: (context) => {
    context.cancelSketchEntitiesTransform?.();
  },
});
